import { gql } from '@apollo/client';

export const DELETE_USER_GUIDE = gql`
    mutation DeleteUserGuide($id: ID!) {
        deleteUserGuide(id: $id) {
            id
        }
    }
`;
